<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Selesai"
      back-button-text="Kembali"
      next-button-text="Lanjut"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <div v-for="item in catatan" :key="item.id">
        <tab-content
        :title="'Catatan Pembimbing'"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
           <b-col cols="12">
                <b-form-group
                  label="Judul"
                  label-for="judul"
                >
                  <b-form-textarea
                    id="judul"
                    rows="3"
                    placeholder="Judul"
                    v-model="item.judul"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Abstrak"
                  label-for="abstrak"
                >
                  <b-form-textarea
                    id="abstrak"
                    rows="3"
                    placeholder="Abstrak"
                    v-model="item.abstrak"
                  />
                </b-form-group>
              </b-col>
               <b-col cols="12">
                <b-form-group
                  label="BAB I"
                  label-for="bab_1"
                >
                  <b-form-textarea
                    id="bab_1"
                    rows="3"
                    placeholder="BAB I"
                    v-model="item.bab_1"
                  />
                </b-form-group>
              </b-col>
               <b-col cols="12">
                <b-form-group
                  label="BAB II"
                  label-for="BAB II"
                >
                  <b-form-textarea
                    id="BAB II"
                    rows="3"
                    placeholder="BAB II"
                    v-model="item.bab_2"
                  />
                </b-form-group>
              </b-col>
               <b-col cols="12">
                <b-form-group
                  label="BAB III"
                  label-for="BAB III"
                >
                  <b-form-textarea
                    id="BAB III"
                    rows="3"
                    placeholder="BAB III"
                    v-model="item.bab_3"
                  />
                </b-form-group>
              </b-col>
               <b-col cols="12">
                <b-form-group
                  label="BAB IV"
                  label-for="BAB IV"
                >
                  <b-form-textarea
                    id="BAB IV"
                    rows="3"
                    placeholder="BAB IV"
                    v-model="item.bab_4"
                  />
                </b-form-group>
              </b-col>
               <b-col cols="12">
                <b-form-group
                  label="BAB V"
                  label-for="BAB V"
                >
                  <b-form-textarea
                    id="BAB V"
                    rows="3"
                    placeholder="BAB V"
                    v-model="item.bab_5"
                  />
                </b-form-group>
              </b-col>
               <b-col cols="12">
                <b-form-group
                  label="Kepustakaan"
                  label-for="Kepustakaan"
                >
                  <b-form-textarea
                    id="Kepustakaan"
                    rows="3"
                    placeholder="Kepustakaan"
                    v-model="item.kepustakaan"
                  />
                </b-form-group>
              </b-col>
               <b-col cols="12">
                <b-form-group
                  label="Lainnya"
                  label-for="Lainnya"
                >
                  <b-form-textarea
                    id="Lainnya"
                    rows="3"
                    placeholder="Lainnya"
                    v-model="item.lainnya"
                  />
                </b-form-group>
              </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      </div>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormTextarea,
} from 'bootstrap-vue'
import { required, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import { codeIcon } from './code'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormTextarea,
  },
  data() {
    var catatan = this.catatan_revisi
    return {
      catatan,
      selectedContry: '',
      selectedLanguage: '',
      name: '',
      emailValue: '',
      PasswordValue: '',
      passwordCon: '',
      first_name: '',
      last_name: '',
      address: '',
      landMark: '',
      pincode: '',
      twitterUrl: '',
      facebookUrl: '',
      googleUrl: '',
      linkedinUrl: '',
      city: '',
      required,
      email,
      codeIcon,
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
    }
  },
  props: {
    catatan_revisi: {},
  },
  methods: {
    formSubmitted() {
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormSocial() {
      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
